import { Card } from '@mui/material'
import User from 'account/dto/User'
import { linkContributorsDepartments } from 'carto/constants/CartoConstants'
import PropTypes from 'prop-types'
import React, { useEffect, useMemo } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import SieauParameterDto from '../../../administration/dto/SieauParameterDto'
import { hasValue } from '../../../utils/NumberUtil'
import { getSetting, getSettingJson } from '../../../utils/SettingUtils'
import HomeAction from '../../actions/HomeAction'
import DtoVigilance from '../../dto/DtoVigilance'
import VigilanceCard from './VigilanceCard'

const VigilancePanel = ({
    townCode,
}) => {
    const {
        vigilances,
        applicationSettings,
        accountUser,
    } = useSelector(store => ({
        vigilances: store.HomeReducer.vigilances,
        applicationSettings: store.AdministrationReducer.applicationSettings,
        accountUser: store.AccountReducer.accountUser,
    }), shallowEqual)


    const dispatch = useDispatch()

    const defaultDepartment = useMemo(() => {
        const contribSettings = hasValue(accountUser.contributorCode) && getSettingJson(applicationSettings, linkContributorsDepartments)?.find(s => s.contributor === accountUser.contributorCode)
        return contribSettings?.departments || getSetting(applicationSettings, 'meteoAlertDepartments')
    }, [accountUser.contributorCode, applicationSettings])

    useEffect(() => {
        const departments = townCode ? townCode.slice(0, 2) : defaultDepartment
        if (hasValue(departments) && departments.length >= 2) {
            dispatch(HomeAction.fetchVigilances(departments))
        }
    }, [defaultDepartment, dispatch, townCode])

    return !!vigilances.length && (
        <Card>
            {vigilances.filter(v => v.texts[0].lang === 'fr-FR').map((vg, index) => (
                <VigilanceCard
                    key={index}
                    vigilance={vg}
                    index={index}
                    size={vigilances.length}
                />
            ))}
        </Card>
    )
}

VigilancePanel.propTypes = {
    townCode: PropTypes.string,
    vigilances: PropTypes.arrayOf(PropTypes.instanceOf(DtoVigilance)),
    applicationSettings: PropTypes.arrayOf(PropTypes.instanceOf(SieauParameterDto)),
    accountUser: PropTypes.instanceOf(User),
    fetchVigilances: PropTypes.func,
    setPopup: PropTypes.func,
}

export default VigilancePanel
